
import { __ } from '@wordpress/i18n';
export const video = () => {
    const videoBlocks = document.querySelectorAll( '.wp-block-video.with-playback-button');
    if (videoBlocks.length == 0) return;
    
    videoBlocks.forEach( block => {
        const video = block.querySelector('video')
        const button = Object.assign( document.createElement('button'), {
            type: 'button',
            className: 'playback-button', 
            textContent: __( 'Play', 'WLC' ),
            onclick: () => video.play()
        })
        block.append(button);

        video.addEventListener('play', () => block.classList.add('playing') );
        ['pause', 'ended'].forEach(eType => video.addEventListener( eType, () => block.classList.remove('playing') ) );

        video.addEventListener('click', () => {
            if (block.classList.contains('playing') ) {
                video.pause();
            };
        });
    })
}